import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { appNav, lazyModalsNav } from 'app/app.navigation';
import { WishlistStreetsService } from 'app/marketplace/services/wishlist-streets.service';
import { iconAssets } from 'core/icons/lib/icon-assets';
import { iconCloseRounded } from 'core/icons/lib/icon-close-rounded';
import { iconEllipsisH } from 'core/icons/lib/icon-ellipsis-h';
import { iconLock } from 'core/icons/lib/icon-lock';
import { iconMoneyChange } from 'core/icons/lib/icon-money-change';
import { iconOval } from 'core/icons/lib/icon-oval';
import { iconStar } from 'core/icons/lib/icon-start';
import { ModalRouter } from 'core/modules/modal';
import { GenericFormControl } from 'core/utils/form-generics';
import { navigateByUrl } from 'core/utils/router.utils';
import { isLoading } from 'core/utils/rxjs/is-loading.operator';
import { CertificatePreviewModal, StreetPreviewModal } from 'dashboard/dashboard.navigation';
import { Street } from 'dashboard/models/street.model';
import { StreetsService } from 'dashboard/services/streets.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-street-item',
  templateUrl: './street-item.component.html',
  styleUrls: ['./street-item.component.scss'],
})
export class StreetItemComponent implements OnDestroy {
  readonly ellipsisIcon = iconEllipsisH;
  readonly starIcon = iconStar;
  readonly cancelIcon = iconCloseRounded;
  readonly exchangeIcon = iconMoneyChange;
  readonly collectIcon = iconAssets;
  readonly spinIcon = iconOval;
  readonly lockEllipsis = iconLock;

  @Input()
  street: Street & { checked?: boolean } = new Street();

  @Input() checked? = false;
  @Output() selected = new EventEmitter();

  @Output() emitTransfer = new EventEmitter<Street>();
  @Output() detached = new EventEmitter<Street>();

  control = new GenericFormControl<boolean>();
  isCancelling?: boolean;
  private destroy$ = new Subject();

  constructor(
    private modal: ModalRouter,
    private wishlistService: WishlistStreetsService,
    private streetService: StreetsService
  ) {}

  @HostBinding('class.disabled')
  get inCollection(): boolean {
    return Boolean(this.street.collectionId);
  }

  @HostListener('click')
  openStreetPreview(): void {
    this.openSellStreet();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleFavorite(): void {
    this.wishlistService.toggleFavorite(this.street);
  }

  openWithdrawNFT(): void {
    this.modal.navigate(lazyModalsNav.dashboard.withdrawNFT(), undefined, {
      data: {
        entity: this.street,
      } as StreetPreviewModal,
    });
  }

  openTransferNFT(): void {
    this.emitTransfer.emit(this.street);
  }

  openSellStreet(): void {
    if (this.street.isEnabledActions) {
      this.modal.navigate(lazyModalsNav.streets.streetSell(), undefined, {
        data: { entity: this.street, preserveQuery: true } as StreetPreviewModal,
      });
    } else {
      this.modal.navigate(lazyModalsNav.streets.streetPreview(), undefined, {
        data: {
          entity: this.street,
          preserveQuery: true,
        } as StreetPreviewModal,
      });
    }
  }

  viewCertificate(): void {
    this.modal.navigate(lazyModalsNav.dashboard.certificatePreview(), undefined, {
      data: {
        nftId: this.street.nft.id.toString(),
      } as CertificatePreviewModal,
    });
  }

  cancelStreetSell(): void {
    this.streetService
      .cancelOrder(this.street)
      .pipe(
        isLoading(v => (this.isCancelling = v)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  viewCollection(): void {
    navigateByUrl(appNav.collectionsNav.userCollection(this.street.collectionId.toString()));
  }

  detachNft(): void {
    this.detached.emit(this.street);
  }
}
